import { PageGen, PdfImage, PdfRect, PdfFont } from './pdf';

export class GLabel {
  private text = '';
  private image?: PdfImage;
  private callback?: (label: GLabel, data: LabelData) => void;

  private constructor(public readonly type: GLabelType) {}

  public static fromText(text: string): GLabel {
    const label = new GLabel(GLabelType.Text);
    label.text = text;
    return label;
  }

  public static fromImage(image: PdfImage): GLabel {
    const label = new GLabel(GLabelType.Image);
    label.image = image;
    return label;
  }

  public static fromImageText(image: PdfImage, text: string): GLabel {
    const label = new GLabel(GLabelType.ImageText);
    label.image = image;
    label.text = text;
    return label;
  }

  public static fromGenerated(callback: (label: GLabel, data: LabelData) => void): GLabel {
    const label = new GLabel(GLabelType.Generated);
    label.callback = callback;
    return label;
  }

  public getText(): string {
    return this.text;
  }
}

export interface LabelData {
  rect: PdfRect;
  page?: PageGen;
  font?: PdfFont;
  singleLine?: boolean;
}

export interface GTuple {
  left: GLabel;
  right: GLabel;
}

export enum GLabelType {
  Text,
  Image,
  ImageText,
  Generated,
}
